<template>
  <div>
    <NBar title="设备操作记录"/>
    <nut-textinput class="my-input" v-model="search" placeholder="请输入设备唯一码或设备名称"
                   :clearBtnPersonnal="true" ref="search" @keyup.enter="submit">
      <template v-slot:clearBtn>
        <nut-icon type="cross"></nut-icon>
      </template>
    </nut-textinput>
    <m-list style="height:calc(100vh - 130px);" ref="list" :data.sync="list" :page.sync="page" :limit.sync="limit"
            @loadlist="getData">
      <div slot="list" v-for="(item,index) in list" :key="index" class='item'>
        <span v-if="item.type == 1" class="label label-1">设备注册</span>
        <span v-if="item.type == 2" class="label label-2">设备转移</span>
        <span v-if="item.type == 3" class="label label-3">设备解绑</span>
        <div class='content'>
          <span class='title'>设备唯一码</span>
          <span class="text">{{item.deviceName}}</span>
        </div>
        <template v-if="item.type == 1">
          <div class='content'>
            <span class='title'>设备注册</span>
            <span class="text">{{item.deviceAddress}}</span>
          </div>
        </template>
        <template v-if="item.type == 2">
          <div class='content'>
            <span class='title'>转出场地</span>
            <span class="text">{{item.outAddress}}</span>
          </div>
          <div class='content'>
            <span class='title'>转入场地</span>
            <span class="text">{{item.deviceAddress}}</span>
          </div>
        </template>
        <template v-if="item.type == 3">
          <div class='content'>
            <span class='title'>解绑场地</span>
            <span class="text">{{item.outAddress}}</span>
          </div>
          <div class='content'>
            <span class='title'>解绑原因</span>
            <span class="text">{{item.remark}}</span>
          </div>
        </template>
        <div class='content'>
          <span class='title'>操作时间</span>
          <span class="text">{{item.addTime}}</span>
        </div>
        <div class='content'>
          <span class='title'>操作人</span>
          <span class="text">{{item.staffName}}</span>
        </div>
      </div>
    </m-list>
  </div>
</template>

<script>
export default {
  name: 'OperateRecord',
  data () {
    return {
      search: '',
      list: [],
      page: 1,
      limit: 10
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    submit () {
      this.getData()
    },
    getData () {
      let data = {
        page: this.page,
        limit: this.limit
      }
      if (!this.$util.isArrOrNull(this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull(this.search)) {
        data.search = this.search
      }
      this.$api.post({
        url: '/device/api/device/device-operate-record/list',
        data: data,
        loading: false
      }).then(res => {
        this.$refs.list.setRes(res)
      })
    }
  }
}
</script>

<style scoped>
  .item {
    position: relative;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 0 10px;
    margin: 0 15px 10px 15px;
    border-radius: 5px;
  }

  .item .label {
    position: absolute;
    top: 0;
    right: 0;
    display: inline-block;
    padding: 2px 5px;
    line-height: 15px;
    text-align: center;
    background: #3d7be8;
    font-size: 9px;
    color: #fff;
    border-top-right-radius: 7px;
    border-bottom-left-radius: 7px;
  }

  .item .label-1 {
    background-color: #4d7ae1;
  }

  .item .label-2 {
    background-color: #7d4de1;
  }

  .item .label-3 {
    background-color: #858c9b;
  }

  .item .content {
    display: flex;
    flex-direction: row;
    height: 30px;
    line-height: 30px;
  }

  .item .content .title {
    flex: 0.3;
  }

  .item .content .text {
    flex: 1;
    display: inline-block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /deep/ .nut-textinput.my-input input {
    height: 36px;
    margin: 10px 15px;
    border-radius: 20px;
    padding-left: 40px;
    padding-right: 40px;
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg version='1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M15.8 14.3l-3.3-3.1c1-1.1 1.6-2.6 1.6-4.1 0-3.6-3.1-6.6-7-6.6s-7 3-7 6.6c0 3.6 3.1 6.6 7 6.6 1.7 0 3.2-.6 4.4-1.5l3.3 3.1c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.7 0-1zM1.5 7.1c0-2.9 2.5-5.2 5.6-5.2 3.1 0 5.6 2.3 5.6 5.2 0 2.9-2.5 5.2-5.6 5.2-3.2 0-5.6-2.3-5.6-5.2z' fill-rule='evenodd' clip-rule='evenodd' fill='%23999'/%3E%3C/svg%3E") no-repeat 10px;
    background-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/OperateRecord.vue